import { createJobTemplate } from "../thunks/createJobTemplate";
import { IActionErrorInfo } from "../types/IActionErrorInfo";
import { JobsExtraBuilder } from "./types/jobsExtraBuilder";

export const addCreateJobTemplate = (builder: JobsExtraBuilder) => {
  builder.addCase(createJobTemplate.fulfilled, (state, action) => {
    if (action.payload.jobID) {
      state.jobsUpdated = [
        ...state.jobsUpdated,
        {
          id: action.payload.jobID,
          message: `Шаблон  "${action.meta.arg.name}" успешно создан`,
        },
      ];
    }
    state.jobCreating = false;
  });

  builder.addCase(createJobTemplate.pending, (state) => {
    state.jobCreating = true;
  });
  builder.addCase(createJobTemplate.rejected, (state, action) => {
    state.jobCreating = false;
    const error: IActionErrorInfo = {
      id: Date.now(),
      message: `Ошибка создания шаблона! "${action.meta.arg.name}": ${action.error.message}`,
    };
    state.jobErrors = state.jobErrors ? [...state.jobErrors, error] : [error];
  });
};
